import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Form from '../../../modules/Form'
import { Container, Row, Col, Nav, NavItem, Breadcrumb, BreadcrumbItem, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert, FormGroup, Label, InputGroup, InputGroupText, InputGroupAddon } from 'reactstrap'
import {
  getAppeal, createAdminReply, getResponses, addTemplateResponse, createPdf, sendPost, clearRichField, deleteAdminReply
} from '../../../actions/adminActions'
import { withRouter } from 'react-router'
import FileUploadAdmin from '../../shared/_FileUploadAdmin'
import FileUploadAdminAdjudicator from '../../shared/_FileUploadAdminAdjudicator'
import Loading from '../../loading'
import RejectAccept from './_RejectAccept'
import PropTypes from 'prop-types'
import { FaPlusCircle, FaFilePdf, FaAt } from 'react-icons/fa'
import RichField from '../../RichField'
import { Document, Page } from 'react-pdf/dist/entry.webpack'
import FileUploadChatAdmin from '../../shared/_FileUploadChatAdmin'
var moment = require('moment')

// import { push } from 'connected-react-router'
const FilterableTable = require('react-filterable-table')

class AdminAppealResponses extends Component {
  constructor (props) {
    super(props)
    this.body = React.createRef(this.body)
    this.sendPdf = this.sendPdf.bind(this)
    this.sendReply = this.sendReply.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.updateOptionsFields = this.updateOptionsFields.bind(this)
    this.timeLimit = React.createRef(this.timeLimit)
    this.showPaymentDetails = React.createRef(this.showPaymentDetails)
    this.pdfTemplate = React.createRef(this.pdfTemplate)
    this.timeLimitTemplate = React.createRef(this.timeLimitTemplate)
    this.timeLimitStatus = React.createRef(this.timeLimitStatus)
    this.afterReplyStatus = React.createRef(this.afterReplyStatus)
    this.afterReplyStatusModal = React.createRef(this.afterReplyStatusModal)
    this.replyModal = this.replyModal.bind(this)
    this.pdfArea = React.createRef(this.pdfArea)
    this.paymentAmount = React.createRef(this.paymentAmount)
    this.deleteMessage = this.deleteMessage.bind(this)

    this.state = {
      pdfWidth: 100
    }
    this.setPDFSize = this.setPDFSize.bind(this)
  }
  componentDidMount () {
    this.props.getAppeal(this.props.match.params.appealID)
    this.props.getResponses()
    if (this.props.admin.appeal.appealID && this.props.admin.responses) {
      this.setPDFSize()
      window.addEventListener('resize', this.setPDFSize)
    }
  }

  componentDidUpdate (prev) {
    if (this.props.admin.appeal.appealID && this.props.admin.auth && this.props.admin.responses) {
      if (!prev.admin.appeal.appealID || !prev.admin.auth || !prev.admin.responses) {
        this.setPDFSize()
        window.addEventListener('resize', this.setPDFSize)
      }
    }
  }

  setPDFSize () {
    this.setState({ pdfWidth: (this.pdfArea.current.getBoundingClientRect().width - 40) })
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.setPDFSize)
  }

  sendPdf () {
    // this.props.handleReplyValue(this.body.current.value)
    this.props.createPdf(this.pdfTemplate.current.value)
  }

  sendReply () {
    // this.props.handleReplyValue(this.body.current.value)
    const data = {
      timeLimit: this.timeLimit.current.value === '0' ? null : parseInt(this.timeLimit.current.value),
      showPaymentDetails: this.showPaymentDetails.current.value === '0' ? null : this.showPaymentDetails.current.value,
      timeLimitTemplate: this.timeLimitTemplate.current.value === 'None' ? null : this.timeLimitTemplate.current.value,
      timeLimitStatus: this.timeLimitStatus.current.value === 'None' ? null : this.timeLimitStatus.current.value,
      paymentAmount: this.paymentAmount.current.value === '0' ? null : this.paymentAmount.current.value,
      afterReplyStatus: this.afterReplyStatus.current.value === 'None' ? null : this.afterReplyStatus.current.value

    }
    this.props.createAdminReply(data)
    this.props.clearRichField()
  }

  toggleModal () {
    // this.props.handleReplyValue(this.body.current.value)
    this.props.toggleModal()
  }

  replyModal () {
    this.props.toggleReplyModal()
  }

  deleteMessage (msg) {
    let r = window.confirm('Are you sure you want to delete this message, the appellant will have already been sent a notifcation that there is a new message regarding this appeal?')

    if (!r) {
      return
    }

    this.props.deleteAdminReply(msg)
  }

  updateOptionsFields (template) {
    console.log(template)
    this.timeLimit.current.value = template.time_limit || 0
    this.showPaymentDetails.current.value = template.show_payment_details || 0
    this.pdfTemplate.current.value = template.pdf_template || null
    this.timeLimitTemplate.current.value = template.time_limit_template || ''
    this.timeLimitStatus.current.value = template.time_limit_status || ''
    this.paymentAmount.current.value = template.payment_amount || 0
    this.afterReplyStatus.current.value = template.after_reply_status || 'pending appellant response'
  }

  render () {
    let theChild

    this.props.replies.sort(function (a, b) {
      const aa = JSON.parse(a)
      const bb = JSON.parse(b)
      return new Date(aa.timestamp) - new Date(bb.timestamp)
    })

    const renderAdd = (props) => {
      return (
        <Button color='primary' className='btn-sm' onClick={() => { this.props.addTemplateResponse(props.value); this.updateOptionsFields(props.record) }}><FaPlusCircle /> Add</Button>
      )
    }

    const fields = [
      { name: 'name', displayName: 'Name', inputFilterable: true, sortable: true },
      { name: 'category', displayName: 'Category', inputFilterable: true, exactFilterable: true, sortable: true },
      { name: 'type', displayName: 'type', inputFilterable: true, exactFilterable: true, sortable: true },
      { name: 'response', displayName: '', inputFilterable: false, exactFilterable: false, sortable: false, render: renderAdd, tdClassName: 'text-right' }

    ]

    if (this.props.admin.appeal.appealID && this.props.admin.auth && this.props.admin.responses) {
      theChild =
        <Container>
          <Row>
            <Col>
              <Breadcrumb>
                <BreadcrumbItem><Link to='/admin'>Appeals</Link></BreadcrumbItem>
                <BreadcrumbItem><Link to={`/admin/appeal/${this.props.admin.appeal.appealID}`}>{this.props.admin.appeal.pcn}</Link></BreadcrumbItem>
                <BreadcrumbItem active>Messaging</BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
          <Row>
            <Col>
              <Nav fill tabs className='mb-3'>
                <NavItem>
                  <Link className='nav-link' to={`/admin/appeal/${this.props.admin.appeal.appealID}`}>Details</Link>
                </NavItem>
                <NavItem>
                  <Link className='nav-link active' to={`/admin/appeal/${this.props.admin.appeal.appealID}/messaging`}>Messaging</Link>
                </NavItem>
              </Nav>
              {(this.props.admin.appeal.manual || !this.props.admin.appeal.email) ? <Alert color='warning'>
                <p>As this appeal was manually added or no email address has been added, so it is likely that responses should be done by physical mail.</p>
              </Alert> : null}
            </Col>
          </Row>
          <Row>
            <Col sm='12' md='8'>
              <div className='chat-area mb-5'>
                <div className='chat chat--them mb-5'>
                  <div ref={this.pdfArea} className='chat__content'>
                    <p>{this.props.admin.appeal.detail}</p>
                  </div>
                  <div className='chat__date'>Appeal Details - {moment(this.props.admin.appeal.data).format('DD/MM/YY')}</div>
                </div>
                {
                  this.props.replies.map((reply, i) => {
                    const msg = JSON.parse(reply)
                    return (
                      <div key={i} className={`chat mb-5 mt-5 ${msg.user === 'adjudicator' ? 'chat--us' : 'chat--them'}`}>
                        <div className='chat__content'>
                          <div dangerouslySetInnerHTML={{ __html: msg.reply }} />
                          {msg.pdfURL && msg.pdfURL.length &&
                            <div>
                              <br />
                              <a target='_blank' href={msg.pdfURL}>
                                <Document file={msg.pdfURL}>
                                  <Page width={this.state.pdfWidth} pageNumber={1} />
                                </Document>
                              </a>
                            </div>
                          }

                        </div>
                        <div className='chat__date'>{msg.user === 'adjudicator' ? 'Admin' : msg.appellant} - {moment(msg.timestamp).format('HH:mm:ss DD/MM/YY')}</div>
                        {msg.user === 'adjudicator' && <Button color='btn-link btn-sm mt-1' onClick={() => this.deleteMessage(msg)}>Delete</Button>
                        }
                      </div>)
                  })}
                <FileUploadChatAdmin />
                <p className='ml-2 mb-4'>Or</p>
                <Form id='emailAdmin' submit={this.props.createAdminReply}>
                  <RichField name='body' id='body' defaultOnChange={this.props.handleReplyValue} defaultValue={this.props.admin.emailValue} innerRef={this.body} />
                  <Input type='hidden' name='appealID' id='appealID' value={this.props.admin.appeal.appealID} />
                  <Input type='hidden' name='email' id='email' defaultValue={this.props.admin.appeal.email} />
                  <Row>
                    <Col className='text-right'>
                      <Button color='secondary' onClick={this.toggleModal}>Response Library</Button>

                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col>
                      <h3>Message Options</h3>
                      <FormGroup>
                        <Label for='show_payment_details'>Show payment button?</Label>
                        <Input innerRef={this.showPaymentDetails} type='select' name='show_payment_details' id={'show_payment_details'} required>
                          <option value='0'>No</option>
                          <option value='1'>Yes</option>
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>
                      <FormGroup>
                        <Label for='payment_amount'>Payment Amount</Label>
                        <InputGroup>
                          <InputGroupAddon addonType='prepend'>
                            <InputGroupText>&pound;</InputGroupText>
                          </InputGroupAddon>
                          <Input innerRef={this.paymentAmount} type='number' min='0' step='0.01' name='payment_amount' defaultValue={0.00} id={'payment_amount'} />

                        </InputGroup>
                        <div className='invalid-feedback' />
                      </FormGroup>
                      <FormGroup>
                        <Label for='after_reply_status'>After sending set the following status:</Label>
                        <Input innerRef={this.afterReplyStatus} defaultValue='pending appellant response' type='select' name='after_reply_status' id={'after_reply_status'}>
                          <option value='registering'>Registering</option>
                          <option value='registered'>Registered</option>
                          <option value='submitted'>Submitted</option>
                          <option value='writing'>Writing</option>
                          <option value='pending appellant response'>Pending appellant response</option>
                          <option value='pending adjudicator response'>Pending adjudicator response</option>
                          <option value='accepted'>Accepted</option>
                          <option value='rejected'>Rejected</option>
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>
                    </Col>
                    <Col>
                      <h3>Auto-responder Options</h3>
                      <FormGroup>
                        <Label for='time_limit'>Time Limit? (0 = no limit)</Label>
                        <InputGroup>
                          <Input innerRef={this.timeLimit} type='number' min='0' step='1' name='time_limit' defaultValue={0} id={'time_limit'} />
                          <InputGroupAddon addonType='append'>
                            <InputGroupText>days</InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                        <div className='invalid-feedback' />
                      </FormGroup>

                      <FormGroup>
                        <Label for='time_limit_template'>After time limit send following response:</Label>
                        <Input innerRef={this.timeLimitTemplate} type='select' name='time_limit_template' id={'time_limit_template'}>
                          <option>None</option>
                          {this.props.admin.responses.map((response, index) => (
                            <option key={index} value={response.id}>{response.name}</option>
                          ))}
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>

                      <FormGroup>
                        <Label for='time_limit_status'>After time limit set following status:</Label>
                        <Input innerRef={this.timeLimitStatus} type='select' name='time_limit_status' id={'time_limit_status'} >
                          <option>None</option>
                          <option value='registering'>Registering</option>
                          <option value='registered'>Registered</option>
                          <option value='submitted'>Submitted</option>
                          <option value='writing'>Writing</option>
                          <option value='pending appellant response'>Pending appellant response</option>
                          <option value='pending adjudicator response'>Pending adjudicator response</option>
                          <option value='accepted'>Accepted</option>
                          <option value='rejected'>Rejected</option>
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button className={`mr-2 ${!this.props.admin.appeal.email ? 'no-spinner' : ''}`} color='primary' onClick={this.replyModal} disabled={(this.props.admin.submitting || !this.props.admin.appeal.email)}><FaAt /> Respond <span className='spinning' /></Button>

                  <hr />
                  <Row>
                    <Col>
                      <h3>PDF Options</h3>
                      <FormGroup>
                        <Label for='pdf_template'>PDF Template</Label>
                        <Input innerRef={this.pdfTemplate} type='select' name='pdf_template' id={'pdf_template'} required>
                          <option value='lettehead'>Letterhead only</option>
                          <option value='reminder'>Reminder</option>
                          <option value='rejection'>Rejection</option>
                        </Input>
                        <div className='invalid-feedback' />
                      </FormGroup>
                    </Col>
                  </Row>

                </Form>
                <Row>
                  <Col>
                    <Button className='mr-2' color='primary' onClick={this.sendPdf} disabled={this.props.admin.pdfing}><FaFilePdf /> PDF <span className='spinning' /></Button>
                    {/* <Button className='mr-2' color='primary' onClick={this.props.sendPost} disabled={this.props.admin.mailing}><FaEnvelope /> Post <span className='spinning' /></Button> */}

                  </Col>

                </Row>

              </div>
            </Col>
            <Col sm='12' md='4'>
              <FileUploadAdmin />
              <FileUploadAdminAdjudicator />
              <hr />
              <RejectAccept status={this.props.admin.appeal.status} />

            </Col>
          </Row>
          <Modal size='lg' isOpen={this.props.admin.responseModal} toggle={this.props.toggleModal}>
            <ModalHeader toggle={this.toggle}>Response Library</ModalHeader>
            <ModalBody>
              {this.props.admin.loading
                ? <div className='table-loading-spinner' />
                : null}
              <FilterableTable
                namespace='Responses'
                initialSort='name'
                data={(this.props.admin.responses !== null) ? this.props.admin.responses : []}
                fields={fields}
                noRecordsMessage='There are no responses to display'
                noFilteredRecordsMessage='No match'
                topPagerVisible={false}
                tableClassName='table table-bordered'
              />
            </ModalBody>
            <ModalFooter>
              <Button color='secondary' onClick={this.props.toggleModal}>Cancel</Button>
            </ModalFooter>
          </Modal>
          <Modal size='lg' isOpen={this.props.admin.replyModal} toggle={this.props.toggleReplyModal}>
            <ModalHeader toggle={this.props.toggleReplyModal}>Confirm Reply</ModalHeader>
            <ModalBody>
              <h3>You are about to send the following message:</h3>
              <div className='conf-message' dangerouslySetInnerHTML={{ __html: this.props.admin.emailValue }} />
              <hr />
              <ul>
                {this.afterReplyStatus.current && this.afterReplyStatus.current.value &&
                  <li className='ml-3'>After sending, the status will be set to: <b>{this.afterReplyStatus.current.value}</b>.</li>
                }
                {this.showPaymentDetails.current && this.showPaymentDetails.current.value !== '0' &&
                  <li className='ml-3'>There will be a payment button for <b>£{this.paymentAmount.current.value}</b>.</li>
                }
                {this.timeLimit.current && this.timeLimit.current.value !== '0' && this.timeLimitTemplate.current && this.timeLimitTemplate.current.value !== 'None' &&
                <li className='ml-3'>There will be timelimit of <b>{this.timeLimit.current.value}</b> days, after which the template <b>{this.props.admin.responses.filter((r) => r.id === this.timeLimitTemplate.current.value)[0].name}</b> will be sent, and the status of the appeal set to <b>{this.timeLimitStatus.current.value}.</b></li>
                }
                {this.timeLimit.current && this.timeLimit.current.value !== '0' && this.timeLimitTemplate.current && this.timeLimitTemplate.current.value === 'None' &&
                <li className='ml-3'>There will be timelimit of <b>{this.timeLimit.current.value}</b> days, after which <b>no template</b> will be sent but the status of the appeal will be set to <b>{this.timeLimitStatus.current.value}.</b></li>
                }
              </ul>
            </ModalBody>
            <ModalFooter>
              <Button color='primary' onClick={this.sendReply} className='mr-2'>Send</Button>
              <Button color='secondary' onClick={this.props.toggleReplyModal}>Cancel</Button>

            </ModalFooter>
          </Modal>
        </Container>
    } else {
      theChild = <Loading />
    }

    return (
      <div>
        {theChild}
      </div>
    )
  }
};

AdminAppealResponses.propTypes = {
  getAppeal: PropTypes.func,
  createAdminReply: PropTypes.func,
  deleteAdminReply: PropTypes.func,
  // sendPost: PropTypes.func,
  admin: PropTypes.object,
  match: PropTypes.object,
  replies: PropTypes.array,
  toggleModal: PropTypes.func,
  toggleReplyModal: PropTypes.func,
  getResponses: PropTypes.func,
  handleReplyValue: PropTypes.func,
  addTemplateResponse: PropTypes.func,
  createPdf: PropTypes.func,
  clearRichField: PropTypes.func
  // goTo: PropTypes.func
}

const mapStateToProps = ({ admin }) => ({
  admin,
  replies: admin.appeal.replies ? Array.from(admin.appeal.replies.values) : []
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAppeal,
      createAdminReply,
      deleteAdminReply,
      getResponses,
      createPdf,
      sendPost,
      clearRichField,
      toggleReplyModal: () => ({ type: '/admin/TOGGLE_REPLY_MODAL' }),
      toggleModal: () => ({ type: '/admin/TOGGLE_RESPONSE_MODAL' }),
      handleReplyValue: (value) => ({ type: '/admin/UPDATE_EMAIL_FIELD_VALUE', value }),
      addTemplateResponse

    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminAppealResponses))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminAppeal/AdminAppealResponses.jsx